import axios from "../config/axios";

export const Addoffertaghook = async (data) => {
    try {
        let respData = await axios({
            'method': 'post',
            'url': `/p2papiadmin/add-offertag`,
            'data': data
        });

        return respData
    } catch (err) {
        return {
            status: "failed",
            loading: false,
            message: err?.response?.data?.message,
            error: err?.response?.data?.errors
        }
    }
}

export const Editoffertaghook = async (data) => {
    try {
        let respData = await axios({
            'method': 'post',
            'url': `/p2papiadmin/edit-offertag`,
            'data': data
        });

        return respData;
    } catch (err) {
        return {
            status: "failed",
            loading: false,
            message: err.response.data.message,
            error: err.response.data.errors
        }
    }
}

export const Getoffertaghook = async (data) => {
    try {
        let respData = await axios({
            'method': 'get',
            'url': `/p2papiadmin/get-offertag`,
            'params': data
        });

        return respData
    } catch (err) {
        return {
            status: "failed",
            loading: false,
            message: err.response.data.message,
            error: err.response.data.errors
        }
    }
}

export const Getofferhistoryhook = async (data) => {
    try {
        let respData = await axios({
            'method': 'get',
            'url': `/p2papiadmin/get-offer-history`,
            'params': data
        });
        console.log("respData in offerhistory" , respData);
        if (data.export == 'csv') {
            const url = window.URL.createObjectURL(new Blob([respData.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Offerhistory.csv');
            document.body.appendChild(link);
            link.click();
        }

        if (data.export == 'xls') {
            const url = window.URL.createObjectURL(new Blob([respData.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Offerhistory.xls');
            document.body.appendChild(link);
            link.click();
        }

        return respData
    } catch (err) {
        return {
            status: "failed",
            loading: false,
            message: err.response.data.message,
            error: err.response.data.errors
        }
    }
}


export const Gettradehistoryhook = async (data) => {
    try {
        let respData = await axios({
            'method': 'get',
            'url': `/p2papiadmin/get-trade-history`,
            'params': data
        });

        if (data.export == 'csv') {
            const url = window.URL.createObjectURL(new Blob([respData.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'currency List.csv');
            document.body.appendChild(link);
            link.click();
        }

        if (data.export == 'xls') {
            const url = window.URL.createObjectURL(new Blob([respData.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'currency List.xls');
            document.body.appendChild(link);
            link.click();
        }

        return respData
    } catch (err) {
        return {
            status: "failed",
            loading: false,
            message: err.response.data.message,
            error: err.response.data.errors
        }
    }
}

export const Getpaymenttypehook = async (data) => {
    try {
        let respData = await axios({
            'method': 'get',
            'url': `/p2papiadmin/get-paymenttypes`,
            'params': data
        });

        return respData
    } catch (err) {
        return {
            status: "failed",
            loading: false,
            message: err.response.data.message,
            error: err.response.data.errors
        }
    }
}


export const Addpaymenttypeshooks = async (data) => {
    try {
        let respData = await axios({
            'method': 'post',
            'url': `/p2papiadmin/add-paymenttypes`,
            'data': data
        });

        return respData
    } catch (err) {
        return {
            status: "failed",
            loading: false,
            message: err?.response?.data?.message,
            error: err?.response?.data?.errors
        }
    }
}

export const Editpaymenttypehooks = async (data) => {
    try {
        let respData = await axios({
            'method': 'post',
            'url': `/p2papiadmin/edit-paymenttypes`,
            'data': data
        });

        return respData;
    } catch (err) {
        return {
            status: "failed",
            loading: false,
            message: err.response.data.message,
            error: err.response.data.errors
        }
    }
}

export const Addownerwallethooks = async (data) => {
    try {
        let respData = await axios({
            'method': 'post',
            'url': `/p2papiadmin/updatewallet`,
            'data': data
        });

        return respData
    } catch (err) {
        return {
            status: "failed",
            loading: false,
            message: err?.response?.data?.message,
            error: err?.response?.data?.errors
        }
    }
}

export const Getownerwallethooks = async (data) => {
    try {
        let respData = await axios({
            'method': 'get',
            'url': `/p2papiadmin/getownerwallet`,
            'params': data
        });

        return respData
    } catch (err) {
        return {
            status: "failed",
            loading: false,
            message: err.response.data.message,
            error: err.response.data.errors
        }
    }
}